import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router';
import { IProject } from '../../redux/project/projectReducer';
import { useAlert } from '../modal/Message';
import './ProjectViewer.css'
import { technology } from '../../config/technology';
import checkimg from './img/checkimg.png'; // 默认背景图
import checkedimg from './img/checkedimg.png'; // 选中背景图
import { Link } from 'react-router-dom';


function SpecialityNavItem(props: {
    to: string
    children?: JSX.Element | JSX.Element[] | string
    onClick?: () => void
    isActive?: boolean // 新增：传递激活状态
}) {
    let match = useRouteMatch({
        path: props.to,
        exact: false
    });

    return (
        <Link
            to={props.to}
            onClick={props.onClick}
            style={{
                color: props.isActive ? '#fff' : '#000', // 激活时白色，默认黑色
                textDecoration: 'none', // 去掉链接下划线
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            {props.children}
        </Link>
    )
}


function ProjectViewer(props: {
    userName: string,
    activeProject: string,
    province?: string,
    city?: string,
}) {
    const [alert, alertJsx] = useAlert();
    const { page } = useParams<{ page: string }>();
    const history = useHistory();
    const { url } = useRouteMatch();


    async function checkProject() {
        if (page !== "project" && !props.activeProject) {
            await alert(<FormattedMessage id="please_choose_project" description="chooseProject" defaultMessage="Please choose project first!" />);
            history.replace(`/${props.userName}/project`);
        }
    }

    useEffect(() => {
        checkProject();
    }, [page]); // eslint-disable-line


    return (
        <>
            <div style={{
                background: '#fff',
                paddingLeft: 20,
                paddingRight: 20,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                transform: 'translateY(-2px)',
                borderRadius: '8px',
                paddingTop: '15px',
                paddingBottom: '15px',
                position: 'relative',
                zIndex: '1',
                marginBottom: 30
            }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent:'end' }}>
                    <div className='newTitle1'>当前工区：</div>
                    <div style={{ marginTop: 10, fontSize: 17, color: '#fb8239', fontWeight: 700, marginLeft: 10 }}>{props.activeProject}({props.province}-{props.city})</div>
                </div>



            </div>

            {alertJsx}
        </>
    )
}

const mapStateToProps = (state: {
    user: { userName: string }
    project: IProject
}) => {
    return {
        userName: state.user.userName,
        activeProject: state.project.activeName,
        province: state.project.province,
        city: state.project.city,
    };
};

export default connect(mapStateToProps)(ProjectViewer);